import { ILanguage } from 'graphql/types';

export const LANGUAGES = Object.keys(ILanguage).reduce(
    (acc, curVal) => ({
        ...acc,
        [ILanguage[curVal]]: `languages.${curVal.toLowerCase()}`,
    }),
    {} as { [key: string]: string }
);
